import { Theme } from '@mui/material';

/**
 * Styling for skillDetailsStyles
 * @returns skillDetailsStyles CSS properties as a JSON object
 * @example skillDetailsStylestyles
*/
const agentSkillsStyles = (theme: Theme, isLessThanMd?: boolean, isAppSpace?: boolean) => {
  const styles = {
    mainContainer: {
      height: isAppSpace ? 'calc(100% - 110px)' : 'calc(100% - 140px)',
    },
    skillsContainer: {
      padding:  '20px 0px 0px 0px',
      width: '100%',
    },
    tableRowContainer:{
      display:'-webkit-box',
      justifyContent:'left',
    },
    skillHeader: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.text.contrastText,
      backgroundColor:theme.palette.background.LogoColor,
      width: '100%',
      padding: '0.55rem 0rem 0.55rem 1rem ',
    },
    tableHeadRow: {      
      'td,th':{
        color:`${theme.palette.secondary.main} !important`,
        fontWeight:'bold',
        textAlign:'left',
        textTransform: 'uppercase',
        position:'sticky',
        backgroundColor:  '#d9ebf5',
      },
      borderBottom: '0.1875rem solid !important', 
      borderBottomColor:`${theme.palette.background.LogoColor} !important` , 
    },
    iconHeaderClasses:{
      lineHeight:2,
      marginLeft:'15px',
      color: theme.palette.text.contrastText,
      fontWeight:'normal',
      textOverflow:'ellipsis',
      overflow:'hidden',
      whiteSpace:'nowrap',
    },
    agentStatesLabel:{      
      margin:'5px',
      minWidth:'25px',
      display:'flex',
      justifyContent:'center',
    },
    tableLabels:{
      lineHeight:2,
      color:theme.palette.text.contrastText,
    },
    subTableLabels:{
      lineHeight:2,
      color:'#007AB8',
    },
    tableStyle:{
      width:'100%',
      backgroundColor:theme.palette.background.paper,
      tableLayout:'fixed',
      borderCollapse:'collapse',
    },
    tableBodyRow:{
      'td, th': {                       
        textAlign:'left',
        fontSize: theme.typography.h5,
        color:theme.palette.text.contrastText,
      },
      borderBottom:'0.1875rem solid',
      borderBottomColor: `${theme.palette.background.LogoColor} !important`,      
      overflowWrap:'anywhere', 
    },
    backIcon: {
      width: '15px',
      height: '15px', 
      cursor: 'pointer',
    },
    skillHeading: {
      fontSize: '0.875rem',
      fontWeight:'bold',
      width: 'fit-content',
    },
    skillsInformation: {
      display: 'flex',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      padding: isLessThanMd || isAppSpace ? '10px 2px' : '20px 15px 20px',
    },
    skillInfoContainer: {
      width: isLessThanMd ? '126px' : '150px',
      padding: isLessThanMd ? '2px' : '5px',
      height:'58px',
      display:'grid',
      alignItems:'center',
    },
    noSkillsInformation: {
      display: 'flex',
      flexDirection:'column',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      padding: isLessThanMd || isAppSpace ? '10px 2px' : '20px 15px 20px',
    },
    skillInfoKey:{
      fontSize: theme.typography.h6,
      fontWeight: 700,
      letterSpacing: '0px',
      color: theme.palette.secondary.light!,
      textTransform: 'uppercase',
      textAlign: 'center',
    },
    noSkillInfoKey:{
      fontSize: theme.typography.h5,
      fontWeight: 700,
      letterSpacing: '0px',
      color: theme.palette.secondary.light!,     
      textAlign: 'center',
      paddingTop:'5px',
    },
    skillInfoValue: {
      textAlign: 'center',
      fontSize: theme.typography.h5,
      fontWeight: 600,
      letterSpacing: '0px',
      color: theme.palette.text.noteLabel,
    },
    skillItems: {
      width: '100%',
      height: isLessThanMd || isAppSpace ? '100%' : 'calc(100% - 10px)',
    },
    skillNoItems: {      
      width: '100%',
      height: 'auto',
    },
    customTableContainer: {    
      height:'90%',
      borderCollapse:'collapse',    
    },
  }
  return styles
}

export default agentSkillsStyles;